import { alpha } from '@mui/material/styles';
import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const Mobile = css``;
export const Tablet = css`
    .ticket-card {
        &.mobil {
            flex-direction: column;
            padding: 12px 0;
            gap: 10px;
            .column-1 {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0 12px;
            }
            .column-2 {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex: 1;
                padding: 0 12px;
                gap: 5px;
            }
            .column-3 {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                padding: 0 12px;
                gap: 10px;
            }
            .column-4 {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex: 1;
                padding: 0 12px;
                gap: 5px;
            }
            .column-5 {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-content: flex-end;
                flex: 1;
                padding: 0 12px;
                padding-top: 12px;
                margin-top: 12px;
                gap: 10px;
                border-top: solid 1px ${alpha('#c1c3c8', 0.4)};
            }

            .thumbnail {
                border-radius: 0;
                width: 100%;
                aspect-ratio: 21/9;
                padding: 0;
                margin: 0;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                img {
                    height: 100%;
                    object-fit: cover;
                    width: 100%;
                }
            }

            .ticket-title {
                font-size: 16px;
                font-weight: 700;
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                align-items: center;
                column-gap: 5px;
                row-gap: 5px;
                .title {
                    width: 100%;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            .ticket-rating {
                line-height: 22px;
            }
            .summary {
                font-size: 12px;
                color: #303641;
                font-weight: 400;

                * {
                    font: inherit !important;
                    background-color: transparent !important;
                    font-size: 12px !important;
                    color: #303641 !important;
                    font-weight: 400 !important;
                }
            }

            .location {
                font-size: 14px;
                color: var(--mui-palette-primary-main);
                /*text-decoration: underline;
                cursor: pointer; */
                font-weight: 500;
                .material-icons {
                    font-size: 1rem;
                }
            }
            .location-km {
                font-size: 14px;
                color: #646a76;
                .material-icons {
                    font-size: 1rem;
                }
            }

            .guest-info {
                font-size: 14px;
            }
            .price-discount {
                width: auto;
                margin: 0 auto;
                margin-right: 0;
                border: solid 1px var(--mui-palette-secondary-main);
                color: var(--mui-palette-secondary-main);
                font-weight: 700;
                padding: 5px 8px;
                border-radius: 4px;
                font-size: 10px;
                .material-icons {
                    font-size: 12px;
                    line-height: 12px;
                }
            }
            .price-info {
                color: #c1c3c8;
                font-size: 1rem;
            }
            .buttons {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
            .price-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                .old-price {
                    font-size: 12px;
                    font-weight: 700;
                    color: #d32f2f;
                    display: flex;
                    align-items: flex-end;
                    position: relative;
                    &::before {
                        content: '';
                        width: 105%;
                        height: 1px;
                        background-color: #d32f2f;
                        position: absolute;
                        left: -5%;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        margin: auto;
                    }
                    .material-icons {
                        font-size: 10px;
                        font-weight: 600;
                        margin-bottom: 4px;
                    }
                }
                .ticket-price {
                    font-size: 20px;
                    font-weight: bold;
                    display: flex;
                    align-items: flex-end;
                    .material-icons {
                        font-size: 13px;
                        font-weight: 600;
                        margin-bottom: 7px;
                    }
                }
            }
        }
    }
`;

export const PageStyled = styled.div`
    .ticket {
        background-color: #fff;
        border-radius: 12px;
        border: solid 1px ${alpha('#c1c3c8', 0.4)};
        outline-offset: -1px;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        color: #303641;

        &:not(.no-animate) {
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.4s ease-out, transform 0.4s ease-out;
            will-change: opacity, visibility;
            transform: translateY(10vh);

            &:hover {
                border-color: #0098c2;
            }

            &.fade-in {
                opacity: 1;
                transform: none;
                visibility: visible;
            }
        }

        .ticket-card {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: stretch;
            position: relative;
            color: #303641;
            &.web {
                gap: 10px;
                flex-direction: row;
                .column-1 {
                    display: flex;
                    flex-direction: column;
                    max-width: 230px;
                    background-color: #f0f4f9;
                    .thumbnail {
                        border-radius: 0;
                        width: 100%;
                        height: 100%;
                        aspect-ratio: 2/2;
                        padding: 0;
                        margin: 0;
                        overflow: hidden;
                        position: relative;
                        .thumbnail-badge {
                            padding: 7px 12px;
                            background-color: var(--mui-palette-secondary-main);
                            color: #fff;
                            font-size: 12px;
                            font-weight: 600;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            gap: 6px;
                            width: fit-content;
                            border-radius: 6px;
                            position: absolute;
                            left: 12px;
                            top: 12px;
                            .material-icons {
                                font-size: 14px;
                            }
                        }
                        img {
                            height: 100%;
                            object-fit: cover;
                            width: 100%;
                        }
                    }
                }
                .column-2 {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    flex: 1;
                    padding: 18px;
                    gap: 5px;
                }
                .column-3 {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: space-between;
                    width: 220px;
                    padding: 18px;
                    border-left: solid 1px ${alpha('#c1c3c8', 0.4)};
                    gap: 8px;
                }
                .ticket-title {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: row;
                    align-items: center;
                    column-gap: 5px;
                }
                .ticket-rating {
                    line-height: 22px;
                }
                .location {
                    font-size: 14px;
                    color: var(--mui-palette-primary-main);
                    /*text-decoration: underline;
                    cursor: pointer; */
                    font-weight: 500;
                    .material-icons {
                        font-size: 1rem;
                    }
                }
                .location-km {
                    font-size: 14px;
                    color: #646a76;
                    .material-icons {
                        font-size: 1rem;
                    }
                }

                .summary {
                    font-size: 12px;
                    color: #303641;
                    font-weight: 400;
                    * {
                        font: inherit !important;
                        background-color: transparent !important;
                        font-size: 12px !important;
                        color: #303641 !important;
                        font-weight: 400 !important;
                    }
                }

                .alert-box {
                    display: flex;
                    gap: 8px;
                }
                .bottom-box {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    gap: 8px;
                }
                .guest-info {
                    font-size: 14px;
                    text-align: right;
                }
                .price-discount {
                    border: solid 1px var(--mui-palette-secondary-main);
                    color: var(--mui-palette-secondary-main);
                    font-weight: 700;
                    padding: 5px 8px;
                    border-radius: 4px;
                    font-size: 10px;
                    .material-icons {
                        font-size: 12px;
                        line-height: 12px;
                    }
                }
                .price-info {
                    color: #c1c3c8;
                    font-size: 1rem;
                }
                .buttons {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    white-space: nowrap;
                }
                .price-box {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    .old-price {
                        font-size: 12px;
                        font-weight: 700;
                        color: #d32f2f;
                        display: flex;
                        align-items: flex-end;
                        position: relative;
                        &::before {
                            content: '';
                            width: 105%;
                            height: 1px;
                            background-color: #d32f2f;
                            position: absolute;
                            left: -5%;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                        }
                        .material-icons {
                            font-size: 10px;
                            font-weight: 600;
                            margin-bottom: 4px;
                        }
                    }
                    .ticket-price {
                        font-size: 20px;
                        font-weight: bold;
                        display: flex;
                        align-items: flex-end;
                        .material-icons {
                            font-size: 13px;
                            font-weight: 600;
                            margin-bottom: 7px;
                        }
                    }
                }
            }
        }
    }

    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
`;
